import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { 
  Globe,
  Settings,
  Play,
  ExternalLink,
} from "lucide-react";
import './Ourinfrastructure.css';

// Infrastructure Images
import chandigarhshowroom from '../img/infrastructure/chandigarh-showroom.jpg';
import mohalifactory from '../img/journey/6.jpg';
import mohalifactory1 from '../img/infrastructure/mohali-factory1.jpg';
import mohalifactory2 from '../img/infrastructure/mohali-factory2.jpg';
import mohalifactory3 from '../img/infrastructure/mohali-factory3.jpg';
import mohalifactory4 from '../img/infrastructure/mohali-factory4.jpg';
import mohalifactory5 from '../img/infrastructure/mohali-factory5.jpg';
import mohalifactory6 from '../img/infrastructure/mohali-factory6.jpg';
import mohalifactory7 from '../img/infrastructure/mohali-factory7.jpg';
import mohalifactory8 from '../img/infrastructure/mohali-factory8.jpg';
import mohalifactory9 from '../img/infrastructure/mohali-factory9.jpg';
import mohalifactory10 from '../img/infrastructure/mohali-factory10.jpg';
import mohalishowroom from '../img/infrastructure/mohali-showroom.jpg';
import ourinfrastructurebanner from '../img/infrastructure/our-infrastructure-banner.jpg';
import rajpurafactoryworking from '../img/infrastructure/rajpura-factory-working.jpg';
import rajpurafactory1 from '../img/infrastructure/rajpura-factory1.jpg';
import rajpurafactory2 from '../img/infrastructure/rajpura-factory2.jpg';
import rajpurafactory3 from '../img/infrastructure/rajpura-factory3.jpg';

// Video assets
import chandigarhvideo from '../video/chandigarhvideo.mp4';
import mohalivideo from '../video/mohalivideo.mp4';

const Ourinfrastructure = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const mohaliGallery = [
    mohalifactory1, mohalifactory2, mohalifactory3, 
    mohalifactory4, mohalifactory5, mohalifactory6,
    mohalifactory7, mohalifactory8, mohalifactory9, mohalifactory10
  ];

  const rajpuraGallery = [
    rajpurafactory1, rajpurafactory2, rajpurafactory3
  ];

  return (
    <div className={`infra-container ${isVisible ? 'is-ready' : ''}`}>
      <Helmet>
        <title>Our Infrastructure | Spinoff - Global Manufacturing Hubs</title>
        <meta name="description" content="Explore Spinoff's world-class manufacturing hubs in Mohali and Rajpura. 250,000+ Sq. Ft. of precision engineering space for green energy and smart lighting." />
        <link rel="preload" href={ourinfrastructurebanner} as="image" />
      </Helmet>
 
      {/* 3D ELITE HERO */}
      <section className="infra-hero">
        <div className="infra-hero-inner">
          <div className="year-badge" style={{background: 'rgba(255,255,255,0.05)', color: '#6366f1'}}>
             <Globe size={14} style={{marginRight: '8px', verticalAlign: 'middle'}} />
             WORLD-CLASS MANUFACTURING HUBS
          </div>
          <h1 style={{fontSize:'55px'}}>Architecting The <span className="highlight-gradient">Future of Industry.</span></h1>
          <p>
            Spinoff Technopark Ltd. commands 250,000+ Sq. Ft. of precision engineering space across 
            Mohali and Rajpura, powering the next evolution of green energy and smart lighting.
          </p>
          <div style={{marginTop: '60px', color: '#6366f1'}}>
            <Settings className="spin" size={64} style={{opacity: 0.3}} />
          </div>
        </div>
      </section>

      {/* HUB SHOWCASE - MOHALI */}
      <section className="hub-section">
        <div className="max-w">
           <div style={{marginBottom: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '20px'}}>
             <div>
                <span className="year-badge">PRECISION HUB A</span>
                <h2 style={{fontSize: 'clamp(1.5rem, 5vw, 2.5rem)', fontWeight: '900', letterSpacing: '-2px'}}>Mohali R&D <span className="highlight-gradient">Center.</span></h2>
             </div>
             <div className="highlight-glass" style={{padding: '16px 32px', display: 'flex', gap: '40px'}}>
                <div style={{textAlign: 'center'}}><h4 style={{fontSize: '24px', fontWeight: '900', color: '#6366f1'}}>20k</h4><p style={{fontSize: '10px', opacity: 0.6}}>SQ FT SPACE</p></div>
                <div style={{textAlign: 'center'}}><h4 style={{fontSize: '24px', fontWeight: '900', color: '#a855f7'}}>SMT</h4><p style={{fontSize: '10px', opacity: 0.6}}>JAPANESE LINES</p></div>
             </div>
           </div>

           <div className="hub-card">
              <div className="hub-image-wrap">
                 <img src={mohalifactory} alt="Mohali Factory" loading="lazy" />
                 <div className="hub-badge">ISO & BIS CERTIFIED</div>
              </div>
              <div className="hub-content">
                  <span style={{color: '#6366f1', display: 'block', marginBottom: '20px', fontWeight: '900', fontSize: '11px', letterSpacing: '2px'}}>MOHALI FACTORY | SPINOFF</span>
                  <h3>Technological Excellence.</h3>
                  <p>
                    North India’s premier manufacturing plant specializing in LED systems. 
                    Featuring integrated facilities including specialized Japanese SMT lines, 
                    production units, and an advanced test lab with Spectrometric analyzers.
                  </p>
                  <ul className="list-angle-right anchor-line" style={{margin: '32px 0', paddingLeft: '20px', listStyle: 'none'}}>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> Innovative LED Manufacturing Hub</li>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> 3000+ In-House Product Portfolio</li>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> Advanced Institutional Test Labs (CE/BIS/RoHS)</li>
                  </ul>
                  <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                    <div className="highlight-glass" style={{padding: '10px 20px', fontSize: '10px', fontWeight: '900', color: '#6366f1'}}>LM80 COMPLIANT</div>
                    <div className="highlight-glass" style={{padding: '10px 20px', fontSize: '10px', fontWeight: '900', color: '#a855f7'}}>ISO 9001:2015</div>
                  </div>
              </div>
           </div>

           {/* MOHALI GALLERY */}
           <div className="gallery-grid">
              {mohaliGallery.map((img, i) => (
                <div key={i} className="gallery-item">
                   <img src={img} alt={`Mohali Factory ${i}`} loading="lazy" />
                </div>
              ))}
           </div>
        </div>
      </section>

      {/* HUB SHOWCASE - RAJPURA */}
      <section className="hub-section" style={{background: '#f8fafc', borderRadius: '100px', margin: '0 20px'}}>
        <div className="max-w">
           <div style={{marginBottom: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap-reverse', gap: '20px'}}>
              <div className="highlight-glass" style={{padding: '16px 32px', display: 'flex', gap: '40px'}}>
                 <div style={{textAlign: 'center'}}><h4 style={{fontSize: '24px', fontWeight: '900', color: '#6366f1'}}>250k</h4><p style={{fontSize: '10px', opacity: 0.6}}>SQ FT SPACE</p></div>
                 <div style={{textAlign: 'center'}}><h4 style={{fontSize: '24px', fontWeight: '900', color: '#a855f7'}}>ESS</h4><p style={{fontSize: '10px', opacity: 0.6}}>LITHIUM HUB</p></div>
              </div>
              <div style={{textAlign: 'right'}}>
                <span className="year-badge">PRECISION HUB B</span>
                <h2 style={{fontSize: 'clamp(2.5rem, 5vw, 2.5rem)', fontWeight: '900', letterSpacing: '-2px'}}>Rajpura Energy <span className="highlight-gradient">Hub.</span></h2>
              </div>
           </div>

           <div className="hub-card" style={{flexDirection: 'row-reverse'}}>
              <div className="hub-image-wrap">
                 <img src={rajpurafactoryworking} alt="Rajpura Factory" loading="lazy" />
                 <div className="hub-badge" style={{left: 'auto', right: '30px'}}>GREEN ENERGY HUB</div>
              </div>
              <div className="hub-content">
                  <span style={{color: '#6366f1', display: 'block', marginBottom: '20px', fontWeight: '900', fontSize: '11px', letterSpacing: '2px'}}>RAJPURA FACTORY | SPINOFF</span>
                  <h3>Cutting-Edge Lithium.</h3>
                  <p>
                    Our newest Mega-Plant, combining lithium battery production with 
                    high-capacity UPS/Inverter ESS systems.
                  </p>
                  <ul className="list-angle-right anchor-line" style={{margin: '32px 0', paddingLeft: '20px', listStyle: 'none'}}>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> High-Volume ESS Solutions for Home, Offices</li>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> Sheet Metal Craft with CNC Laser Precision</li>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> Advanced Powder Coating Facilities</li>
                    <li style={{marginBottom: '12px', position: 'relative'}}><span style={{color: '#6366f1', position: 'absolute', left: '-20px'}}>▹</span> Own injection molding with full support of Tool Room, CNC and VMC Machines, Advanced EDM Working facilities with 3D design Solutions</li>
                  </ul>
                  <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                    <div className="highlight-glass" style={{padding: '10px 20px', fontSize: '10px', fontWeight: '900', color: '#6366f1'}}>NPD DRIVEN</div>
                    <div className="highlight-glass" style={{padding: '10px 20px', fontSize: '10px', fontWeight: '900', color: '#a855f7'}}>METAL CRAFT HUB</div>
                  </div>
              </div>
           </div>

           {/* RAJPURA GALLERY */}
         
        </div>
      </section>

   

    </div>
  );
};

export default Ourinfrastructure;